import RailwayRepository from './railwaysRepository'
import SectorRepository from './sectorsRepository'
import StationRepository from './stationsRepository'
import PlatformRepository from './platformsRepository'
import BridgeRepository from './bridgesRepository'
import ShedRepository from './shedsRepository'
import FencingRepository from './fencingsRepository'
import PillarRepository from './pillarsRepository'
import MainWireRepository from './mainWiresRepository'
import ContactWireRepository from './contactWiresRepository'

export default {
    RailwayRepository,
    SectorRepository,
    StationRepository,
    PlatformRepository,
    BridgeRepository,
    ShedRepository,
    FencingRepository,
    PillarRepository,
    MainWireRepository,
    ContactWireRepository
}
